import { Outlet } from "react-router-dom";

const PreLogin = () => <Outlet />;

export default PreLogin;
